module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// C:/Work/repo/metabase/metabase_wh/node_modules/crossfilter/index.js
// module id = 208
// module chunks = 7